import i18n from "@/boot/i18n";

const iEmptyData = (data, isFolder = false, emptyData = 'na') => {
  try {
    if (typeof data === 'number') return data;
    const isEmpty =
      (Array.isArray(data) && !data.length) ||
      data === null || data === 'null' ||
      data === undefined || data === 'undefined' ||
      (typeof data === 'string' && !data.trim());

    if (isEmpty) {
      return isFolder ? '' : i18n.global.t(`common.${emptyData}`);
    }
    return data;
  } catch (e) {
    return data;
  }
}

export {
  iEmptyData,
}
